import { Div, Icon, Label, Loader } from "@grassrootly/rn-core";
import { ScreenLayout } from "../../layout/components";
import { MainStackScreenProps } from "../../navigation/Navigation.types";
import GamePreview from "../../common/game/GamePreview";
import { useHome } from "./useHome";

export default function HomeScreen({ navigation }: MainStackScreenProps<"home">) {
  const { game, loading } = useHome();
  return (
    <ScreenLayout
      header={{
        center: `FEATURED GAME`,
        left: <Icon name="menu" size={24} onPress={navigation.toggleDrawer} classNames={["mb-{5}"]} />,
      }}
    >
      {game ? <GamePreview game={game} /> : null}
      {!game ? (
        <Div classNames={["flex1", "alignContentCenter", "mt-{30}"]}>
          {loading ? (
            <Loader size="large" isLoading />
          ) : (
            <Label type="l1Bold" classNames={["textCenter", "colorSecondaryLight"]}>
              No games scheduled
            </Label>
          )}
        </Div>
      ) : null}
    </ScreenLayout>
  );
}
